export type IFlyerTabResources = typeof FlyersTabResources;

export const FlyersTabResources = {
    locationTile: "Propozycje gazetek dla lokalizacji:",
    mostPopularFlyers: {
        title: "Najpopularniejsze gazetki promocyjne",
    },
    brands: {
        title: "Wszystkie gazetki promocyjne",
        filtersTitle: "Wszystkie",
        showMoreBtn: "Zobacz więcej",
    },
};
